import { createMigrate, type PersistedState } from 'redux-persist'

const migrations = {
  1: (state: PersistedState) => state,
}

export const GALLERY_PERSIST_VERSION = 1

export const galleryMigrate = createMigrate(migrations, { debug: false })
